let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '统计日期',
        props: 'statisDate',
        minWidth: 200,
    },
    {
        label: '当日充电桩共享总数',
        props: 'shareCountAll',
        minWidth: 200,
        tooltip: true,
    },
    {
        label: '当日充电桩共享占比',
        props: 'shareRatioAll',
        minWidth: 200,
    },
    {
        label: '环比',
        props: 'yoyAll',
        minWidth: 120,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyAll = String(row.yoyAll)
            if(row.yoyAll.indexOf('+')>-1){
                let num =row.yoyAll.substring(1)*100
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyAll.indexOf('-')>-1) {
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyAll*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '增长量',
        props: 'increaseAll',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseAll = String(row.increaseAll)
            if(row.increaseAll.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseAll.indexOf('-')>-1) {
                console.log(row.increaseAll.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseAll*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '开启共享桩数',
        props: 'shareOpenCount',
        minWidth: 120,
    },
    {
        label: '关闭共享桩数',
        props: 'shareCloseCount',
        minWidth: 200,
    },
    {
        label: '当日共享订单数',
        props: 'shareOrderDayCount',
        minWidth: 200,
    },
    {
        label: '共享收益',
        props: 'shareFee',
        minWidth: 200,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
}, {
    type: 'title',
    name: '运营分析',
},
    {
    type: 'title',
    name: '用户数据信息',
},
{
    type: 'title',
    name: '私桩共享设置列表'
},  ];


// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileModelDetail',
};

// 路由
pageConfig.listRouter = 'orderManageList';

pageConfig.orderDeatilRouter = 'orderDetail';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'router',
    name: '充电订单管理',
    router: 'orderManageList'
},
{
    type: 'title',
    name: '订单详情',
}];

pageConfig.formRules = {
    refundStatus: [{
        required: true,
        message: '请选择是否退款',
        trigger: 'change'
    }],
    toCustReceipt: [{
        required: true,
        message: '请填写车主回执',
        trigger: 'blur'
    }],
    freeServiceFee: [{
        required: true,
        message: '请填写服务费免征额',
        trigger: 'blur'
    }],
    serviceReceipt: [{
        required: true,
        message: '请填写运营商回执',
        trigger: 'blur'
    }],
};

pageConfig.orderFormRules = {
    chargeOverReason: [{
        required: true,
        message: '请填写结束充电原因',
        trigger: 'change'
    }]
};

export default pageConfig;
